module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/038-cape-verde-a78b90ee12c3c61b3117735280c311dc.svg";